import script from "./AdminSubmissions.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSubmissions.vue?vue&type=script&setup=true&lang=js"

import "./AdminSubmissions.vue?vue&type=style&index=0&id=3dc20cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc20cc6"]])

export default __exports__